export default "__VITE_ASSET__RZfVRzse__"